import React from "react";
import { IModalInstance } from "@whatslly/ui-components/modals";
import { ConfirmModal } from "@whatslly/ui-components/modals/ConfirmModal";
import { useTranslation } from "react-i18next";

export const DisableUserModal: React.FC<IModalInstance> = ({ closeModal }) => {
  const { t } = useTranslation();
  return (
    <ConfirmModal
      closeModal={closeModal}
      title={t("user_management.disable_user_modal.title")}
      okText={t("user_management.disable_user_modal.okText")}
    >
      <div>{t("user_management.disable_user_modal.line1")}</div>
      <div>{t("user_management.disable_user_modal.line2")}</div>
    </ConfirmModal>
  );
};
